import React from 'react'
import { withRouter } from 'react-router-dom'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import { connect } from 'react-redux'
import Pagination from '../../../components/pagination/pagination.component'
import './sales.styles.scss'
import Service from './sales.service'
import NumberFormat from 'react-number-format'

class Sales extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadSales()
    }

    onPageChange = page => {
        this.setState({
            ...this.state,
            currentPage: page
        }, () => this.service.loadSales())
    }

    onFilterChange = e => {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                value: "",
                [e.target.name]: e.target.value
            }
        })
    }

    onFilterSubmit = e => {
        e.preventDefault()
        this.service.loadSales()
    }

    getStatusLabel = status => {
        switch(status){
            case 1:
                return "Pending"
            case 2:
                return "Processed"
            case 3:
                return "Cancelled"
            default:
                return "Unknown"
        }
    }

    render() {
        return (
            <>
                {this.state.loadingSales && <Dialog><Loading /></Dialog>}
                <div className="sales">
                    <div className="header">
                        <h4>Sales</h4>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Customer</th>
                                <th>Description</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>SalePoint</th>
                                <th>PlacedBy</th>
                                <th>Created</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.orders.map((order, key) => <tr key={key}>
                                    <td>{order.customer.userId} {order.customer.name}</td>
                                    <td>{order.description}</td>
                                    <td><NumberFormat value={order.amount} displayType={'text'} thousandSeparator={true} prefix={'N'} renderText={value => value} /></td>
                                    <td>{this.getStatusLabel(order.status)}</td>
                                    <td>{order.salePoint !== null ? order.salePoint.name : ""}</td>
                                    <td>{order.placedBy !== null ? order.placedBy.username : ""}</td>
                                    <td>{new Date(order.created * 1000).toString("dd MMM yyyy HH:mm:ss")}</td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                    {
                        this.state.total > 0 && <Pagination totalItemsCount={this.state.total} currentIndex={this.state.currentPage} itemsPerPage={this.state.pageSize} onChange={this.onPageChange} />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Sales))